<template>
  <div class="newreport">
    <z-fix-top
      v-if="isShowHead"
      ref="fixtop"
      keep-position
      class="fixtop"
      :style="{background: '#F7F7F7'}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navTitle"
          @click-left="handleClickLeft"
      >
      </z-nav-bar>
    </z-fix-top>
    <div class="content">
      <div class="icon">
        <img :src="iconMap[status]"/>
      </div>
      <div class="title">
        {{titleMap[status]}}
      </div>
     <div class="desc">
      {{tipsMap[status]}}
     </div>
      <ProductCard/>
    </div>
    <z-button-group class="bottom-button" v-if="['2', '4'].includes(status)">
      <z-button type="primary" @click="skipToConfirmPage">重新申请</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { NavBar, FixTop, Button, ButtonGroup } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '@lib/utils'
import { queryDisclosureEmail } from '@api/resourceApi'
import ProductCard from '../Components/productCard.vue';
import native from '@zz-common/native-adapter';

const query = queryParams()

export default {
  name: 'InformationDisclosureResult',
  data() {
    return {
      navTitle: '信息披露申请',
      uid: getCookie('uid'),
      email: '',
      orderId: query.orderId || this.$route.query.orderId || '',
      from: query.from || this.$route.query.from || '',
      status: query.status || this.$route.query.status || '',
      isShowHead: false,
      iconMap: {
        1: require('../images/success.png'),
        2: require('../images/sorry.png'),
        3: require('../images/success.png'),
        4: require('../images/wrong.png'),
        5: require('../images/success.png')
      },
      titleMap: {
        1: '申请通过',
        2: '申请不通过',
        3: '已成功提交审核',
        4: '申请已关闭',
        5: '已成功提交审核'
      }
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    zButtonGroup: ButtonGroup,
    zButton: Button,
    ProductCard
  },
  computed: {
    tipsMap() {
      return {
        1: `交易另一方资料已发送您的${this.email}邮箱，请注意查收`,
        2: '非常抱歉，您的信息披露申请未通过。很抱歉未能给您提供愉快的交易体验，您可以于转转APP内联系平台官方客服介入进行纠纷调解',
        3: `平台预计48小时内完成审核并反馈审核结果，如果审核通过，将会把交易另一方资料发送至您的${this.email}邮箱，请注意查收`,
        4: '因您超时未提交，申请通道现已关闭',
        5: `平台预计48小时内完成审核并反馈审核结果，如果审核通过，将会把交易另一方资料发送至您的${this.email}邮箱，请注意查收`
      }
    }
  },
  methods: {
    skipToConfirmPage() {
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/confirm?orderId=${this.orderId}&from=${this.from}`,
        needClose: '1'
      })
    },
    handleClickLeft() {
      native.close()
    }
  },
  created() {
    if (native.in('miniprogram')) {
      this.isShowHead = false
    }
    native.setTitle({
      title: '信息披露申请'
    })
    //状态1,3,5需要回显邮箱
    if (this.status == '1' || this.status == '3' || this.status == '5') {
      const params = {
        uid: this.uid,
        orderId: this.orderId
      }
      queryDisclosureEmail(params).then(res => {
        this.email = res.mail
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
